<template>
  <div class="table">
    <el-row class="table-warpper" v-show="chaerShow">
      <el-col :span="6" class="table-title">机构分析</el-col>
      <el-col :span="15" class="buttonChange timeButton">
      </el-col>
      <el-col :span="3" class="table-icon">
        <div @click="showPopup">
          <img src="../../../../static/images/screen.png" style="width:.2rem;height:.2rem">
        </div>
        <van-popup v-model="screenShow">
          <table-screens ref="screen" :otherFiler="nameData" v-on:childByValue="childByValue" :timeIndex="timeIndex" :calendarData="dateData"></table-screens>
        </van-popup>
      </el-col>
    </el-row>
    <div ref="tableWrapper" v-if="clearTable" :class="{ 'defTable':notmore,'fixTop':isMore }">
      <el-table
        ref="operativeTable"
        :data="showData"
        v-loading="loading"
        style="width: 100%"
        row-key="id"
        border
        lazy
        node-key="id"
        :height="popHeight"
        :load="load"
        @expand-change="changeRow"
        :expand-row-keys="expands"
        @sort-change="sortProportion"
        :header-cell-class-name="handleTheadAddClass"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :class="{ 'tableList5': notmore,'table-itme':true }">
        <el-table-column
          :key="Math.random()"
          fixed
          prop="sname"
          label="机构"
          min-width="134"
          sortable='custom'
          class="demo-table-expand widthStyle">
          <template slot-scope="scope">
            <label :class="scope.row.id">{{ scope.row.sname }}</label>
          </template>
        </el-table-column>
        <el-table-column
        v-if="jumpShow"
        :key="Math.random()"
        prop="comparedWith"
        :label="'查看\n个人绩效'"
        min-width="100">
          <template slot-scope="scope">
            <label v-if="scope.row.hasJump" @click = jumpMenoth(scope.row.id) ><img src="../../../../static/images/navigation.png" style="width:.2rem;height:.2rem"></label>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="achievement"
          :label="reachName"
          min-width="133"
          sortable='custom'
          class="widthStyle">
          <template slot-scope="scope">
            <label v-if="scope.row.achievement !== null && quota.charAt(0) !== 'B'">{{ (scope.row.achievement).toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1') }}
            {{scopeUnitFn(scope.row.achievementUnit)}}</label>
            <label v-else-if="scope.row.achievement !== null && quota.charAt(0) === 'B'">{{scope.row.achievement}}
            {{scopeUnitFn(scope.row.achievementUnit)}}</label>
            <label v-else>--</label>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="rank"
          sortable='custom'
          label="排名"
          min-width="105"
          class="widthStyle">
          <template slot-scope="scope">
            {{ scope.row.rank }}
            <label v-if="scope.row.flag === 3">--</label>
            <span v-else>
              <span class="updown">
                <img v-if="scope.row.flag === 2" src="../../../../static/images/up.png" alt="">
                <img v-if="scope.row.flag === 1" src="../../../../static/images/down.png" alt="">
              </span>
              <span :class="{ down:1===scope.row.flag }">
                {{ scope.row.rankChange }}
              </span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24"><div @click="showMore" class="more">{{moreText}}</div></el-col>
      </el-row>
    </div>
    <div @click="scrollRight" v-if="rightImg" class="rightImg">
      <img src="../../../../static/images/icon_more2.png" alt="">
    </div>
    <home-commonbg class="showImg" v-if="loadFlag"></home-commonbg>
  </div>
</template>

<script>
import HomeCommonbg from '../../common/commonBg'
import TableScreens from '../../common/screens/ScreensOpe'
import { postAction, getAction } from '@/utils/api'
// import {getUrlKey} from '@/utils/util'
import { handleUserSessionStorage } from '@/utils/util'
export default {
  name: 'Table',
  components: {
    TableScreens,
    HomeCommonbg
  },
  props: ['dateData', 'year'],
  data () {
    return {
      testData: [],
      rightImg: false, // 表格指示图标状态
      type: 1,
      moreFlag: true,
      showData: [],
      loading: '',
      moreText: '查看更多',
      screenShow: false,
      showTabledata: null,
      tableData: {},
      timeIndex: null,
      popHeight: '',
      getData: '',
      reachName: '',
      rateName: '',
      getUrl: '', //  获取url的indexId
      getUrl1: '', //  获取url的businessId
      getOrgId: '', //  获取url的orgId
      getLevel: '', //  获取url的level
      firstLevel: [], // 筛选中的一级数据
      secondLevel: [], // 筛选中的二级数据
      newTableData: [], // 有层级的全部数据
      showNewTableData: [], // 筛选后的有层级的所有数据
      reachObj: null,
      compareObj: null,
      rateObj: null,
      ratioObj: null,
      compareUnit: '',
      completionUnit: '',
      nameData: '',
      showFlag: null,
      downNum: '',
      chaerShow: true,
      clearTable: true,
      hasAccountFor: null, // 判断是否显示占比（1为显示0不显示）
      indexOrd: [],
      expands: [],
      curThead: '',
      sequenceOrder: null, // 表格列排序的顺序 ascending 正序 descending 倒序 null 默认
      isMore: false, // 控制查看更多时表格样式
      notmore: true, // 控制查看更多时表格样式
      loadFlag: false,
      totalRow: {},
      currentIndex: 0, // 判断初次进入页面 不触发watch ,触发则会调用两次
      cloumProp: null,
      jumpShow: false // 跳转列时候显示
    }
  },
  methods: {
    jumpMenoth (val) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否跳转到员工看板查看该机构负责人的绩效考核情况',
        confirmButtonText: '是',
        cancelButtonText: '否',
        confirmButtonColor: '#008AFF'
      })
        .then(() => {
          this.getHref(val)
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    // 请求调转href
    getHref (val) {
      var getPostdata = {
        pageCode: this.$store.state.user.pageCode,
        orgId: val,
        date: this.year || ''
      }
      var getFlag = getAction('performance/province/leader', getPostdata)
      getFlag.then(res => {
        if (res.code === 0) {
          // 处理用户sessionStorage
          handleUserSessionStorage()
          // location.href = this.ygkbJumpUrl + '?QueryUserCode=' + res.data.userId + '&OrgNo=' + res.data.orgId + '&type=ssxh' + '&QueryYear=' + res.data.year
          let url = this.ygkbJumpUrl + '?QueryUserCode=' + res.data.userId + '&OrgNo=' + res.data.orgId + '&type=ssxh' + '&QueryYear=' + res.data.year
          let callBackUrlParam = encodeURIComponent(btoa(unescape(encodeURIComponent(url))))
          location.href = this.ygkbDandianJumpUrl + '&callbackUrl=' + callBackUrlParam
        } else {
          // this.$dialog.alert({
          //   title: '提示',
          //   message: res.msg,
          //   confirmButtonColor: '#008AFF'})
          // alert(res.msg)
        }
      })
    },
    handleOnScroll () { // ****** 添加方法1，监听滚动事件
      const tableWrapper = this.$refs.tableWrapper
      const headerEl = tableWrapper.querySelector('.el-table__header-wrapper')
      const isScrollEnd = headerEl.scrollWidth === headerEl.scrollLeft + headerEl.clientWidth
      this.rightImg = !isScrollEnd && this.showData
      // this.rightImg = this.timeIndex === 3 && this.showData && !isScrollEnd
      headerEl.addEventListener('scroll', (e) => {
        const isScrollEnd = headerEl.scrollWidth === headerEl.scrollLeft + headerEl.clientWidth
        this.rightImg = !isScrollEnd && this.showData
        // this.rightImg = this.timeIndex === 3 && this.showData && !isScrollEnd
      })
    },
    scrollRight () { // ****** 添加方法2，点击图标触发的事件
      const tableWrapper = this.$refs.tableWrapper
      // const scrollWidth = tableWrapper.clientWidth + tableWrapper.scrollLeft

      const headerEl = tableWrapper.querySelector('.el-table__header-wrapper')
      const bodyEl = tableWrapper.querySelector('.el-table__body-wrapper')
      const scrollWidth = tableWrapper.clientWidth + headerEl.scrollLeft

      const ths = [...headerEl.querySelectorAll('th')] // es6数组解构
      const colsWidth = ths.map(th => th.clientWidth)
      let scrollLeft = 0
      for (let width of colsWidth) {
        scrollLeft += width
        if (scrollLeft > scrollWidth) {
          this.rightImg = false
          break
        }
      }
      const left = scrollLeft - scrollWidth + headerEl.scrollLeft + 15
      headerEl.scrollLeft = left // scrollLeft所有浏览器都支持，很老的旧版本IE都支持
      bodyEl.scrollLeft = left
    },
    sortProportion (column) {
      this.curThead = column.prop
      // 判断是否是总公司还是分公司账号登录
      if (this.$store.state.user.level !== '1') {
        if (column.order === null) {
          // this.showData = JSON.parse(JSON.stringify(this.testData))
          // 分公司角色默认排名列排序
          if (this.showData[0].rankChange === null || this.showData[0].rankChange === 0) {
            this.showData[0].flag = 3
          } else {
            if (this.showData[0].rankChange < 0) {
              // 分公司用户分公司一条数据判断是都rangkChange<0 然后对齐进行绝对值转换
              this.showData[0].rankChange = Math.abs(this.showData[0].rankChange)
              this.showData[0].flag = 1
            } else {
              this.showData[0].flag = 2
            }
          }
          // return
        }
        this.sortChild(this.showData, column.prop, column.order)
      } else {
        this.totalDealSortArr(column.prop, column.order)
      }
    },
    sortChild (array, prop, order) { // 分公司排序
      array.forEach((item) => {
        if (item.hasOwnProperty('children')) {
          if (order === null) {
            item.children.sort((a, b) => b.achievement - a.achievement)
          } else {
            if (prop === 'sname') {
              order === 'ascending' ? item.children.sort((a, b) => a.id - b.id) : item.children.sort((a, b) => b.id - a.id)
            } else if (prop === 'achievement') {
              order === 'ascending' ? item.children.sort((a, b) => a.achievement - b.achievement) : item.children.sort((a, b) => b.achievement - a.achievement)
            } else if (prop === 'rank') {
              order === 'ascending' ? item.children.sort((a, b) => a.rank - b.rank) : item.children.sort((a, b) => b.rank - a.rank)
            }
          }
        }
      })
    },
    // colData判断是哪一列  flagData 判断是升序还是降序
    totalDealSortArr (colData, flagData) { // 总公司排序
      let result = JSON.parse(JSON.stringify(this.tableData))
      if (this.$store.state.user.level === '1') {
        result.forEach(item => {
          if (item.id === '__total__row__') {
            let delIndex = result.findIndex((val) => val.id === '__total__row__')
            result.splice(delIndex, 1)
          }
          // 判定id 截取合计行
          if (item.id === '86') {
            let delIndex = result.findIndex((val) => val.id === '86')
            result.splice(delIndex, 1)
          }
        })
      }
      if (flagData === 'ascending') {
        if (this.sequenceOrder === 'ascending' && this.cloumProp === colData) {
          this.sequenceOrder = null
          // this.showData.shift()
          setTimeout(() => {
            $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
            $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
          }, 200)
        } else {
          setTimeout(() => {
            $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
          }, 200)
          if (this.$store.state.user.level === '1') {
            if (colData === 'sname') {
              result.sort((a, b) => a.id - b.id)
            } else {
              result.sort((a, b) => a[colData] - b[colData])
            }
          } else {
            if (colData === 'sname') {
              result[0].children.sort((a, b) => a.id - b.id)
            } else {
              result[0].children.sort((a, b) => a[colData] - b[colData])
            }
          }
          this.sequenceOrder = 'ascending'
          this.cloumProp = colData
        }
      } else if (flagData === 'descending') {
        if (this.sequenceOrder === 'descending' && this.cloumProp === colData) {
          this.sequenceOrder = null
          setTimeout(() => {
            $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
            $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
          }, 200)
        } else {
          setTimeout(() => {
            $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
          }, 200)
          if (this.$store.state.user.level === '1') {
            if (colData === 'sname') {
              result.sort((a, b) => b.id - a.id)
            } else {
              result.sort((a, b) => b[colData] - a[colData])
            }
          } else {
            if (colData === 'sname') {
              result[0].children.sort((a, b) => b.id - a.id)
            } else {
              result[0].children.sort((a, b) => b[colData] - a[colData])
            }
          }
          this.sequenceOrder = 'descending'
          this.cloumProp = colData
        }
      } else {
        this.sequenceOrder = 'null'
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#C0C4CC'})
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#C0C4CC'})
            }, 200)
      }
      if (this.moreText === '收起' && this.$store.state.user.level === '1') {
        result.unshift(this.totalRow)
      }
      this.showData = result
      console.log(this.showData)
    },
    handleTheadAddClass (column) {
      // 判断找到当前列添加样式
      if (column.column.property === this.curThead) {
        return 'active-thead'
      }
    },
    changeRow (row, expandeexpandeddRows) {
      // this.expands = this.expands.distinct()
      /* eslint no-extend-native: ["error", { "exceptions": ["Array"] }] */
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val)
        if (index > -1) {
          this.splice(index, 1)
        }
      }
      Array.prototype.distinct = function () {
        let arr = this
        let obj = {}
        let result = []
        for (let i = 0; i < arr.length; i++) {
          if (!obj[arr[i]]) { // 如果能查找到，证明数组元素重复了
            obj[arr[i]] = 1
            result.push(arr[i])
          }
        }
        return result
      }
      if (expandeexpandeddRows) {
        if (this.expands.indexOf(row.id) < 0) {
          this.expands.push(row.id)
        }
      } else {
        if (this.expands.indexOf(row.id) !== -1) {
          this.expands.remove(row.id)
        }
      }
      this.expands = this.expands.distinct()
    },
    noRepeat (treeData) {
      /* eslint no-extend-native: ["error", { "exceptions": ["Array"] }] */
      Array.prototype.distinct = function () {
        let arr = this
        let obj = {}
        let result = []
        for (let i = 0; i < arr.length; i++) {
          if (!obj[arr[i].id]) { // 如果能查找到，证明数组元素重复了
            obj[arr[i].id] = 1
            result.push(arr[i])
          }
        }
        return result
      }
      // 判断是treeData.tableData还是treeData.distinct()
      treeData = treeData.tableData
      return treeData
    },
    getHomeInfo () {
      let ins = this.currentIndex
      this.currentIndex = ins + 1
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.$store.state.ope.quota,
        channelId: '0101',
        date: this.dateData || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
        this.hasAccountFor = res.data.hasAccountFor
      })
      if (this.type === 1) {
        let postData = {
          'channelId': '0101',
          'classification': this.$store.state.ope.kind,
          'dateType': this.$store.state.ope.time,
          'indexId': [this.$store.state.ope.quota],
          'date': this.dateData || '',
          'level': this.$store.state.user.level,
          'orgId': this.$store.state.user.orgId,
          'type': 1
        }
        this.getData = postAction('/performance/yeJiOperation/getOrgAnalyListParent', postData)
      }
      // else {
      //   let postData1 = {
      //     'channelId': this.$store.state.ope.detailChannel,
      //     'classification': this.$store.state.ope.kind,
      //     'dateType': this.$store.state.ope.time,
      //     'indexId': [this.$store.state.ope.quota],
      //     'date': this.dateData || '',
      //     'key': '',
      //     'level': this.$store.state.user.level,
      //     'orgId': this.$store.state.user.orgId
      //   }
      //   this.getData = postAction('/simpapp/whole/topBranch', postData1)
      // }
      this.getData.then((res) => {
        res.data.tableData.forEach((item) => {
          if (item.hasJump === true) {
            this.jumpShow = true
          }
        })
        if (this.$store.state.user.orgId === '86') {
          // 表示只再总公司用户登录才执行合计行id:_total_row_
          this.totalRow = res.data.tableData[0]
          this.tableDataAny = res.data.tableData
          // this.totalRow.id = '__total__row__'
          this.newTableData = res.data.tableData.slice(1)
          this.tableData = res.data.tableData.slice(1)
          this.showTabledata = res.data.tableData.slice(1)
          this.showData = res.data.tableData.slice(1)
        } else {
          this.newTableData = res.data.tableData
          this.tableData = res.data.tableData
          this.testData = JSON.parse(JSON.stringify(res.data.tableData))
          this.showTabledata = res.data.tableData
          this.showData = res.data.tableData
          console.log(this.showData)
        }
        this.nameData = res.data.headerData
        this.completionUnit = this.nameData.completionRateUnit
        this.compareUnit = this.nameData.comparedWithUnit
        this.completionUnit = this.nameData.completionRateUnit
        this.reachName = this.nameData.achievementName // 接口返回的字段名，表头达成列的名字
        this.rateName = this.nameData.completionRateName
        this.changeTable()
        if (this.$store.state.user.level > 1 && this.quota.charAt(0) !== 'B' && this.quota !== 'D0104-1051' && this.quota !== 'D0104-1052' && this.quota !== 'D0104-1053') {
          this.loadNextData(this.showData[0])
          this.expands.push(this.showData[0].id)
        }
        this.$nextTick(() => {
          this.handleOnScroll()
        })
      })
    },
    /*
    *进行数据懒加载的方法
    * 共有三个参数 获取的远程数据通过resolve进行装载
    * 每次装载完成后，将其状态treeNode.loaded 变成false 下次展开继续进行远程加载
    * 由于展开后再点击也还会加载 需要判断是否为展开状态 如果是 就将其收起并推出
    * 否则进行继续的远程加载并展开
    *
    */
    load (tree, treeNode, resolve) {
      // loaded为false 即加载完成
      this.downNum = ''
      if (treeNode.loaded === false && treeNode.expanded === true) {
        this.$refs.operativeTable.toggleRowExpansion(tree, false)
        treeNode.loading = false
        return
      }
      // 第一次加载为懒加载，然后之后每次默认已经执行懒加载了之后不在执行
      if (this.$store.state.user.level === '1') {
        if (tree.hasChildren && tree.children && tree.children.length) {
          resolve(tree.children)
          return
        }
      }
      this.loadNextData(tree, treeNode, resolve)
    },
    // 下钻
    loadNextData (tree, treeNode, resolve) {
      let treeData = []
      let secpostData = {
        'channelId': '0101',
        'classification': this.$store.state.ope.kind,
        'dateType': this.$store.state.ope.time,
        'indexId': [this.$store.state.ope.quota],
        'date': this.dateData || '',
        'level': tree.nextLevel,
        'orgId': tree.id,
        'type': 1
      }
      let obj = postAction('/performance/yeJiOperation/getOrgAnalyListChild', secpostData)
      obj.then((res) => {
        if (this.$store.state.user.level !== '1') {
          if (this.testData[0].children) {
            // 分公司角色登录判断俩个数组中是否有相同的项
            res.data.tableData.filter(n => {
              return this.testData[0].children.includes(n) !== -1
            })
          } else {
            this.testData[0].children = res.data.tableData
            this.showData[0].children = res.data.tableData
          }
        }
        treeData = res.data.tableData
        if (treeData.length) { // 获取子级机构数量
          this.downNum = treeData.length
        }
        // 循环定义一个全量的数据并且有父子级别关系
        for (let i = 0; this.newTableData.length > i; i++) {
          if (tree.id === this.newTableData[i].id) {
            // 总公司登录
            if (this.$store.state.user.level === '1') {
              if (this.newTableData[i].children) {
                this.newTableData[i].children = res.data
              } else {
                this.newTableData[i].children = []
              }
            // 分公司账号
            } else {
              this.newTableData[i].children = res.data.tableData || []
            }
          }
        }
        if (tree.nextLevel === 2 && this.secondLevel.length !== 0) {
          var newTreeDataS = []
          for (let k = 0; treeData.length > k; k++) {
            var newTreeData = treeData[k].id
            for (let m = 0; this.secondLevel.length > m; m++) { // 二级筛选
              var newSecondLevel = this.secondLevel[m].orgCode
              if (newSecondLevel === newTreeData) {
                newTreeDataS.push(treeData[k])
              }
            }
          }
          if (newTreeDataS.length > 0) {
            treeData = newTreeDataS
          }
        }
        if (tree.nextLevel === 2 || this.type === 2) {
          for (let i = 0; i < treeData.length; i++) {
            treeData[i].hasChildren = false
          }
        }
        // 选择达成指标进行筛选--下钻筛选.最大值区间值需要转换数据类型为Number然后在判断数据大小
        if (this.reachObj && treeData.length > 0) {
          if (this.reachObj.reachMin !== '') {
            treeData = treeData.filter((item) => {
              return Number(item.achievement) >= Number(this.reachObj.reachMin)
            })
          }
          if (this.reachObj.reachMax !== '') {
            treeData = treeData.filter((item) => {
              return Number(item.achievement) <= Number(this.reachObj.reachMax)
            })
          }
          if (this.reachObj.reachMin !== '' && this.reachObj.reachMax !== '') {
            treeData = treeData.filter((item) => {
              return Number(item.achievement) >= Number(this.reachObj.reachMin) && Number(item.achievement) <= Number(this.reachObj.reachMax)
            })
          }
        }
        // 控制排名的上升下降箭头---下钻
        for (let i = 0; i < treeData.length; i++) {
          if (treeData[i].rankChange === null || treeData[i].rankChange === 0) {
            treeData[i].flag = 3
          } else {
            if (treeData[i].rankChange < 0) {
              treeData[i].rankChange = Math.abs(treeData[i].rankChange)
              treeData[i].flag = 1
            } else {
              treeData[i].rankChange = Math.abs(treeData[i].rankChange)
              treeData[i].flag = 2
            }
          }
        }
        // treeData = this.noRepeat(treeData)
        let chooseChildArr
        // 对子集做处理
        for (let i = 0; this.showData.length > i; i++) {
          if (tree.id === this.showData[i].id) {
            chooseChildArr = []
            this.showData[i].children = JSON.parse(JSON.stringify(chooseChildArr))
            this.showData[i].children = treeData
          }
        }
        // 当前使用中支 如 九江 863302 进行筛选,添加本部分逻辑为筛选机构可以筛选到中支
        if (this.secondLevel.length > 0) {
          let tmpArr = []
          let secondLevel = this.secondLevel
          this.showData.forEach((item, index) => {
            tmpArr[index] = item

            if (item.hasOwnProperty('children') && item.children !== null && item.children.length > 0) {
              // 置空 tmpArr children
              let children = item.children
              tmpArr[index].children = []
              children.forEach(childItem => {
                secondLevel.forEach(secondItem => {
                  if (secondItem.orgCode === childItem.id) {
                    tmpArr[index].children.push(childItem)
                  }
                })
              })
            }
          })
          console.log(tmpArr)
        }
        if (this.expands.indexOf(tree.id) < 0) {
          this.expands.push(tree.id)
        } else {
          this.$nextTick(() => {
            this.expands.push(tree.id)
          })
        }
        if (resolve) {
          if (this.$store.state.user.level === '1') {
            resolve(treeData) // 进行数据加载
          } else {
            this.showData[0].children = treeData
          }
          this.$refs.operativeTable.toggleRowExpansion(tree, true)
          treeNode.loading = false
          if (tree.nextLevel < 3) {
            treeNode.loaded = false // 加载完成后将加载状态置为 false
          }
          this.showData = JSON.parse(JSON.stringify(this.showData))
        } else {
          this.expands = this.indexOrd
          if (treeNode) {
            if (treeNode[0] === treeNode[1]) {
              this.loadFlag = false
            }
          } else {
            this.showData = JSON.parse(JSON.stringify(this.showData))
          }
        }
        this.testData = JSON.parse(JSON.stringify(this.showData))
      })
    },
    childByValue (childValue, firstLevel, secondLevel, reachObj, compareObj, rateObj, ratioObj) {
      let branchIdArr = [] // 保存机构展开的id数组
      this.downNum = ''
      // childValue就是子组件传过来的值
      this.screenShow = childValue
      if (!firstLevel) { return } // 如果没有获取到一级数据 那么直接关闭筛选框
      // 清除表格数据
      this.clearTable = false
      setTimeout(() => {
        this.clearTable = true
        this.$nextTick(() => {
          this.handleOnScroll()
        })
      }, 100)
      // 装载筛选后的数据并将其赋值给 this.showData
      this.showNewTableData = []
      this.showData = [] // 将源数据置空
      // 一级条件筛选数据
      // this.firstLevel = firstLevel
      this.firstLevel = firstLevel.filter(function (x, index, self) {
        return self.indexOf(x) === index
      })
      // 二级条件筛选数据 排重
      // this.secondLevel = secondLevel
      this.secondLevel = secondLevel.filter(function (x, index, self) {
        return self.indexOf(x) === index
      })
      this.reachObj = reachObj // 一下为其他条件筛选数据--达成
      this.compareObj = compareObj
      this.rateObj = rateObj
      this.ratioObj = ratioObj
      if (firstLevel && firstLevel.length !== 0) {
        if (firstLevel.length === this.newTableData.length && secondLevel && secondLevel.length === 0) {
          this.showData = this.newTableData
          this.testData = JSON.parse(JSON.stringify(this.newTableData))
        } else {
          // this.branchFilterHandle()
          /*
          * 通过机构筛选，选择出需要展开的数据orgCode并将其返回到branchIdArr中
          * */
          branchIdArr = this.branchFilterHandle()
          if (secondLevel && secondLevel.length > 0) {
            this.expands = branchIdArr
          } else {
            this.expands = []
          }
          // 其他过滤条件 如果是一级为空就将所有的数据放入到展示数据中
          this.showData = JSON.parse(JSON.stringify(this.showNewTableData))
          this.tableData = JSON.parse(JSON.stringify(this.showNewTableData))
          this.testData = JSON.parse(JSON.stringify(this.showNewTableData))
        }
      } else if (firstLevel.length === 0) {
        this.showData = this.newTableData
      }
      /*
      *
      * 通过筛选出来的需要展开的orgCode数据将其放到其他过滤条件中，因为有可能其他过滤条件将其数据过滤掉
      * 所以在进行一步循环确定最终需要展开的数据
      * */
      if (this.$store.state.user.level > 1) {
        if (this.quota.charAt(0) === 'B' || this.$store.state.ope.quota === 'D0104-1051' || this.$store.state.ope.quota === 'D0104-1052' || this.$store.state.ope.quota === 'D0104-1053') {
          this.expands = []
        } else {
          this.expands = [this.showData[0].id]
        }
      } else {
        if (secondLevel && secondLevel.length > 0) {
          this.expands = this.otherTableFilterHandle(branchIdArr)
        } else {
          this.otherTableFilterHandle(branchIdArr)
          this.expands = []
        }
      }
      this.indexOrd = JSON.parse(JSON.stringify(this.expands))
      // this.closeExpanded() // 关闭表格的展开
      // 对子集做处理
      // this.indexOrd = JSON.parse(JSON.stringify(this.expands))
      this.expandRows(this.indexOrd)
    },
    expandRows (expandsedRows) {
      if (expandsedRows.length > 0) {
        this.loadFlag = true
        let roundNum = [0, expandsedRows.length - 1]
        for (let i = 0; expandsedRows.length > i; i++) {
          for (let j = 0; this.showData.length > j; j++) {
            if (expandsedRows[i] === this.showData[j].id) {
              roundNum[0] = i
              this.loadNextData(this.showData[j], roundNum)
            }
          }
        }
      }
    },
    closeExpanded () {
      for (let i = 0; i < this.showData.length; i++) {
        try {
          this.$refs.operativeTable.toggleRowExpansion(this.showData[i], false)
        } catch (err) {
        }
      }
    },
    /*
    *机构进行筛选的方法
    */
    branchFilterHandle () {
      let branchIdArr = []
      // 一级筛选 （确定后的）
      /*
      * 通过一级firstLevel条件数据中orgCode 跟newTableData全局数据对比
      * 取出相对应的数据 存放的需要展示的表格数据showNewTableData中
      * 然后在对其进行二级筛选
      */
      for (let i = 0; i < this.newTableData.length; i++) { // 一级
        var newTableDataS = this.newTableData[i].id // 表格中的数据
        var NewProvinceCode = this.newTableData[i].provinceCode // 表格中的数据
        for (let n = 0; this.firstLevel.length > n; n++) { // 一级筛选
          var newFirstLevel = this.firstLevel[n].orgCode
          if (newFirstLevel === newTableDataS || newFirstLevel === NewProvinceCode) {
            this.showNewTableData.push(this.newTableData[i])
          }
        }
      }
      /*
      * 通过二级secondLevel传过来的orgCode 跟一级筛选中获取数据showNewTableData中所有的children 进行
      * code对比然后将其放入数组secondSel中 并赋值给一级筛选中对应的children中
       *
        * */
      for (let m = 0; this.secondLevel.length > m; m++) { // 二级筛选中将子数据的父id保存到数据中并作为后续展开时候查询子数据用
        if (branchIdArr.indexOf(this.secondLevel[m].parentId) === -1) {
          branchIdArr.push(this.secondLevel[m].parentId)
        }
      }
      if (!NewProvinceCode) {
        // 分公司二级筛选 （确定后的）
        /*
        * 通过二级secondLevel传过来的orgCode 跟一级筛选中获取数据showNewTableData中所有的children 进行
        * code对比然后将其放入数组secondSel中 并赋值给一级筛选中对应的children中
        */
        for (let p = 0; p < this.showNewTableData.length; p++) {
          let secondSel = []
          if (this.showNewTableData[p].children) { // 二级
            for (let j = 0; this.showNewTableData[p].children.length > j; j++) {
              var newTableDataT = this.showNewTableData[p].children[j].id
              for (let m = 0; this.secondLevel.length > m; m++) { // 二级筛选
                var newSecondLevel = this.secondLevel[m].orgCode
                if (newSecondLevel === newTableDataT) {
                  secondSel.push(this.showNewTableData[p].children[j])
                }
              }
            }
            this.showNewTableData[p].children = secondSel
            if (branchIdArr.indexOf(this.showNewTableData[p].id) === -1) {
              branchIdArr.push(this.showNewTableData[p].id)
            }
          }
        }
      } else if (this.secondLevel.length >= 1 && this.showNewTableData.length < 100) {
        // 百强中支的二级筛选
        var showTableDataNewTwo = [] // 备份数据
        var secondSelNewTwo = new Set()
        // var secondSelNewTwoSS = new Set()
        var item = this.showNewTableData
        for (let k = 0; k < this.showNewTableData.length; k++) {
          // console.log(secondSelNewTwo)
          var showTableOneNewTwo = this.showNewTableData[k].provinceCode
          // var showTableOneNewTwoC = this.showNewTableData[k].branchCode
          for (let h = 0; h < this.secondLevel.length; h++) {
            var secondLevelNewTwo = new Set()
            secondLevelNewTwo = this.secondLevel[h].parentId
            // var secondlevelNewTwoC = this.secondLevel[h].orgCode
            if (showTableOneNewTwo === secondLevelNewTwo) {
              console.log('删除相同的父级', secondLevelNewTwo)
              secondSelNewTwo = item.filter(item => item.provinceCode !== secondLevelNewTwo)
              item = secondSelNewTwo
            }
            // if (secondlevelNewTwoC === showTableOneNewTwoC) {
            //   showTableDataNewTwo.push(this.showNewTableData[k])
            // }
          }
        }
        for (let g = 0; g < this.showNewTableData.length; g++) {
          var showTableOneNewTwoC = this.showNewTableData[g].branchCode
          for (let t = 0; t < this.secondLevel.length; t++) {
            var secondlevelNewTwoC = this.secondLevel[t].orgCode
            if (secondlevelNewTwoC === showTableOneNewTwoC) {
              showTableDataNewTwo.push(this.showNewTableData[g])
            }
          }
        }
        this.showNewTableData = secondSelNewTwo
        this.showNewTableData = this.showNewTableData.concat(showTableDataNewTwo)
        // 排序
        this.showNewTableData.sort(function (a, b) {
          return a.rank - b.rank
        })
      }
      return branchIdArr
    },
    /*
    *
    * 其他条件进行的表格遍历
    */
    otherTableFilterHandle (branchIdArr) {
      this.$nextTick(() => {
        if (this.firstLevel.length === 0) {
          this.showData = JSON.parse(JSON.stringify(this.showTabledata))
        }
        // 进入页面的初始化筛选
        // 设定新数组判断是否是总公司用户登录筛选总公司筛选分公司数据，分公司筛选中支数据
        var compareData = []
        compareData = this.$store.state.user.level === '1' ? this.showData : this.showData[0].children
        if (this.reachObj) {
          if (this.reachObj.reachMin !== '') {
            compareData = compareData.filter((item) => {
              return Number(item.achievement) >= Number(this.reachObj.reachMin)
            })
          }
          if (this.reachObj.reachMax !== '') {
            compareData = compareData.filter((item) => {
              return Number(item.achievement) <= Number(this.reachObj.reachMax)
            })
          }
          if (this.reachObj.reachMin !== '' && this.reachObj.reachMax !== '') {
            compareData = compareData.filter((item) => {
              return Number(item.achievement) >= Number(this.reachObj.reachMin) && Number(item.achievement) <= Number(this.reachObj.reachMax)
            })
          }
        }
        if (this.$store.state.user.level === '1') {
          this.showData = compareData
          this.tableData = compareData
        } else {
          this.showData[0].children = compareData
          this.testData[0].children = compareData
        }
      })
      let chooseArr = []
      // 把筛选过后的选中数据重新保存
      for (let i = 0; i < this.showData.length; i++) {
        if (branchIdArr.indexOf(this.showData[i].id) !== -1) {
          chooseArr.push(this.showData[i].id)
        }
      }
      return chooseArr
    },
    showPopup () {
      this.screenShow = true
      this.$store.commit('SCREENS_SET_TOPHUNDRED', this.type)
      this.$refs.screen.getInitialData()
    },
    showMore () {
      if (this.sequenceOrder === 'ascending') {
          setTimeout(() => {
            $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
          }, 200)
      } else if (this.sequenceOrder === 'descending') {
          setTimeout(() => {
            $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
          }, 200)
      }
      if (this.moreFlag) {
        this.isMore = true
        this.notmore = false
        this.chaerShow = false
        this.moreText = '收起'
        if (this.$store.state.user.level === '1') {
          this.showData.unshift(this.totalRow)
        }
        this.$emit('chaerShowClick', false)
        this.popHeight = document.documentElement.clientHeight - 40
        this.moreFlag = !this.moreFlag
      } else {
        this.isMore = false
        this.notmore = true
        this.chaerShow = true
        this.moreText = '查看更多'
        if (this.$store.state.user.orgId === '86') {
          this.showData.shift()
        }
        this.$emit('chaerShowClick', true)
        this.popHeight = ''
        this.moreFlag = !this.moreFlag
      }
    },
    changeType (index) {
      this.expands = []
      this.clearScreen()
      try {
        this.$refs.screen.clearSelectedBranchs()
      } catch (err) {
      }
      this.type = index
      this.getHomeInfo()
      this.$store.commit('SCREENS_SET_TOPHUNDRED', index)
      console.log('表格传给筛选的数据', this.$store.state.screens.TopHundred)
    },
    clearScreen () {
      this.firstLevel = [] // 一级条件筛选数据
      this.secondLevel = [] // 二级条件筛选数据
      this.reachObj = null // 一下为其他条件筛选数据
      this.compareObj = null
      this.rateObj = null
      this.ratioObj = null
    },
    changeTable () {
      this.moreText = '查看更多'
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.type === 1) {
          // 判断当指标为智多新使用率时机构分析默认下钻到二级机构
          if (this.showTabledata[i].id.length > 2 && this.$store.state.ope.quota.charAt(0) !== 'B' && this.$store.state.ope.quota !== 'D0104-1051' && this.$store.state.ope.quota !== 'D0104-1052' && this.$store.state.ope.quota !== 'D0104-1053') {
            this.showTabledata[i].hasChildren = true
          } else {
            this.showTabledata[i].hasChildren = false
          }
        } else {
          this.showTabledata[i].hasChildren = false
        }
        if (this.tableData[i].rankChange === null || this.tableData[i].rankChange === 0) {
          this.showTabledata[i].flag = 3
        } else {
          if (this.tableData[i].rankChange < 0) {
            this.showTabledata[i].rankChange = Math.abs(this.showTabledata[i].rankChange)
            this.showTabledata[i].flag = 1
          } else {
            this.showTabledata[i].rankChange = Math.abs(this.showTabledata[i].rankChange)
            this.showTabledata[i].flag = 2
          }
        }
      }
      this.closeExpanded() // 关闭表格的展开
    },
    // 处理指定指标（）单位
    scopeUnitFn (data) {
      if (this.quota === 'D0104-1051' || this.quota === 'D0104-1052' || this.quota === 'D0104-1053' || this.quota === 'D0104-1054' || this.quota === 'D0104-1005' || this.quota === 'D0104-1001' || this.quota === 'B0701-1001' || this.quota === 'D0104-1008' || this.quota === 'D0104-1040' || this.quota.charAt(0) === 'B') {
        return data
      } else {
        return ''
      }
    }
  },
  mounted () {
    // console.log(window.location.href, '从Android和iOS获取的url截取参数')
    //  从Android和iOS获取的url截取参数
    // this.getCode = getUrlKey('pageCode', window.location.href)
    // this.getUrl = getUrlKey('indexId', window.location.href)
    // this.getUrl1 = getUrlKey('businessId', window.location.href)
    // this.getOrgId = getUrlKey('orgId', window.location.href)
    // this.getLevel = getUrlKey('level', window.location.href)
    // if (this.getUrl && this.getUrl1) {
    //   //  重新在vuex中管理参数
    //   this.$store.commit('USER_SET_PAGE_CODE', this.getCode)
    //   this.$store.commit('USER_SET_ORG', this.getOrgId)
    //   this.$store.commit('USER_SET_LEVEL', this.getLevel)
    //   this.$store.commit('OPE_SET_KIND', this.getUrl1)
    //   this.$store.commit('OPE_SET_QUOTA', this.getUrl)
    // }
    this.quota = this.$store.state.ope.quota
    this.timeIndex = this.$store.state.ope.time
    this.getHomeInfo()
  },
  computed: {
    getChannel () {
      return this.$store.state.ope.detailChannel
    },
    getTime () {
      return this.$store.state.ope.time
    },
    getQuota () {
      return this.$store.state.ope.quota
    }
  },
  watch: {
    showData () {
      this.key = this.key + 1
    },
    timeIndex () {
      this.$nextTick(() => {
        this.expands = []
        this.clearScreen()
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
          // if (this.timeIndex === 3) { // ****** 渲染年的表格时绑定滚动事件
          //   this.handleOnScroll()
          // }
        }, 100)
        if (this.currentIndex !== 0) {
          this.getHomeInfo()
        }
      })
    },
    dateData () {
      this.$nextTick(() => {
        this.expands = []
        this.clearScreen()
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
          this.getHomeInfo()
      })
    },
    getChannel () {
      this.$nextTick(() => {
        this.expands = []
        this.clearScreen()
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
          this.getHomeInfo()
       })
    },
    getTime () {
      this.$nextTick(() => {
        this.expands = []
        this.clearScreen()
        this.timeIndex = this.$store.state.ope.time
        if (this.timeIndex === 3 && this.showData) { // 判断表格知识图标出现状态
          console.log('出现箭头')
          this.rightImg = true
        } else {
          this.rightImg = false
        }
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.clearTable = false
        setTimeout(() => {
          this.clearTable = true
        }, 100)
          this.getHomeInfo()
      })
    },
    getQuota () {
      try {
        this.$refs.screen.clearSelectedBranchs()
      } catch (err) {
      }
      this.$nextTick(() => {
        this.getHomeInfo()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  /deep/.el-table th .cell {
      /*text-align: center;*/
      white-space: pre-line !important;/*保留换行符*/
  }
  >>>table.el-table__header{
    width: 100%;
    margin-left: -2px;
  }
  >>>table.el-table__body{
    width: 100%;
    // padding-right: 10px;
  }
  /deep/.el-table__row{
    width: 100%;
    height: 0.53rem;
  }
  >>>.tableList5{
    max-height: 3.24rem;
    overflow: hidden;
  }
  .table {
    position: relative;
    margin-bottom:0;
  }
  .table-warpper{
    margin-top: 0.1rem;
    padding: 0px 15px;
    background: #fff;
  }
  .table-itme>>>.el-table__expand-icon{
    float : left;
  }
  .table-itme>>>td,.table-itme>>>th{
    border-right: none;
    text-align : center;
  }
  .table-itme>>>span.el-table__indent{
    padding-left : 0!important;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-1{
    background : #F9F9F9;
  }
  .table-itme>>>.el-table__expand-icon{
    // margin-right: -40px;
    // margin-left: 5px;
  }
  // .table-itme>>>tr.el-table__row.el-table__row--level-1:nth-child(0) .cell{
  //   margin-right: 20px
  // }
  .table-itme>>>span.el-table__placeholder{ // 不同级别缩进相同(不分等级级别对齐)
    width : 0;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-2 {
      background: #eee;
  }
  .van-popup.van-popup--center{
    width : 90%;
    // height : 60%;
    border-radius : .06rem;
    background #fff;
  }
  .table-title,.table-icon{
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
  }
  .table-icon{
    text-align : right;
  }
  .table-itme>>>.el-table__expanded-cell{
    padding: 0;
    padding-left: 48px;
  }
  .table-itme>>>.el-form--inline .el-form-item__content{
    padding-left: 4px;
    padding-right: 4px;
  }
  .table-itme>>>.cell{
    padding-left: 4px !important;
    padding-right: 0px !important;
  }
  .table-itme>>>td.el-table__expanded-cell{
    background: #F9F9F9;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .demo-table-expand{
    // display: flex;
  }
  .more{
    line-height:.4rem;
    text-align: center;
    color:#3399FF;
    background: #ffffff;
    font-size: .14rem
  }
  .buttonChange {
    font-size: 0;
    text-align: right;
    height: 0.45rem;
    line-height: 0.45rem;
  }

  .buttonChange button {
    height: 0.26rem;
    line-height: 0.26rem;
    border: none;
    margin: 0;
    font-size: 0;
    font-size: 0.14rem;
    padding: 0 15px;
    color: #39f;
    background: none;
    border: 1px solid #39f;
    border-radius: 0.02rem;
  }

  .timeButton button {
    border: 1px solid #F2F2F2;
    color: #999;
  }

  .buttonChange .choose {
    background: #3399FF;
    border: 1px solid #3399FF;
    color: #fff;
    border-radius: 0.02rem;
  }
  .table-itme span{
    color: #FB6E6C;
  }
  .table-itme label{
    font-weight:normal
  }
  .table-itme .down{
    color: #00C29E;
  }
  .updown img{
    width: .18rem
    height: .18rem
  }
  .fixTop{
    width:100%;
    min-height:100vh;
    // position : fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    // z-index:999999999;
  }
  >>>colgroup{
    overflow: hidden;
    display: none;
  }
  .widthStyle{
    width:33%
  }
  .rightImg{ // 表格指示图标
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 0;
  }
  .el-table__fixed{
    z-index: 9999999;
  }
  .showImg{
    position flex
    z-index 999999999999999
  }
  // >>>.el-table__header-wrapper{
  //   padding-left: 10px;
  // }
</style>



// WEBPACK FOOTER //
// src/pages/operate/components/OperateTable.vue